import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Categoría de soporte al usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Category {
    public id = 0
    public name = ''
    public module = ''
    public children: Category[] = []
    public parent = 0

    public get isNew () {
        return !this.id
    }

    /**
     * Busca una categoría por id entre todos sus descendientes
     *
     * @param id
     */
    public findCategory (id: number): Category | null {
        if (this.id === id) {
            return this
        }

        for (const child of this.children) {
            const candidate = child.findCategory(id)
            if (candidate) {
                return candidate
            }
        }

        return null
    }

    /**
     * Busca una categoría entre todas sus descendientes
     *
     * @param id
     */
    public removeCategory (id: number): void {
        if (this.id === id) {
            return
        }

        const index = this.children.findIndex(c => c.id === id)
        index !== -1 && this.children.splice(index, 1)

        for (const children of this.children) {
            children.removeCategory(id)
        }
    }

    public static deserialize (data: KeyValuePair): Category {
        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
            module: data.module,
            parent: data.parent,
            children: Array.isArray(data.children) ? data.children.map(c => Category.deserialize(c)) : [],
        })
    }

    public serialize () {
        return {
            name: this.name,
            module: this.module,
            parent: this.parent,
        }
    }
}
